import React,{useState,useEffect} from 'react';
import { Container,Row,Col } from 'react-bootstrap';
import './styles/App.css';
import M_Footer from './M_Footer';
import {Link} from 'react-router-dom';
import TopTitle from './TopTitle';
import queryString from 'query-string';
import axios from 'axios';
import { comma,instance } from './common';


function totalPrice(data){
    let price = 0;
    data.forEach(function(v){
        price += Number(v.s_member_price);
    });
    return comma(price);
}

function totalCount(data){
    
    return Number(data.length-1);
}




function SigongId({si_id,data,setData}){


    

    let obj = {si_id:1}
    useEffect(() => {
        
        const fetchData = async () => {
            instance.post('/sigong/id',obj).then(function(res){

                setData(res.data[0]);        
            });
 
        };

        fetchData();

    }, []);


    const {si_name,si_address} = data;

    return (
        <>
            <h3 className="font-weight-bold mb-3" id="si_name">{si_name}</h3>
            <span id="si_address">{si_address}</span>
        </>
    )
}


function ServiceId({u_id,u_type,s_date,data2,setData2}){

    //const [data, setData] = useState([]);

    let obj = {u_id:u_id}
    useEffect(() => {
        
        const fetchData = async () => {
            instance.post('/cart/id',obj).then(function(res){

                setData2(res.data.rows);
          

            });
 
        };

        fetchData();

    }, []);
    let s_cate ='';
    if(data2.length !=0){
        s_cate = data2[0].s_cate;
    }
    return (
        <>
            {
                data2.map(v =><div className="row p-0 mt-2 mb-5" key={v.s_id}>
                <div className="col-4 p-0" id="s_img">
                    <div className="r_r_bg" style={{backgroundImage:'url('+v.s_img+')'}}></div>
                </div>
                <div className="col-8 pr-0">
                    <div className="font-weight-bold r_title mb-2" id="s_name">{v.s_name}</div>
                    <div className="r_subtext mb-5" id="s_content"></div>
                    <div className="r_r_color font-weight-bold r_title" id="s_price">
                        {
                            u_type == '일반고객'
                            ?comma(v.s_price)
                            :comma(v.s_member_price)
                    }원</div>
                </div>
            </div>)
            }
            <div className="r_b_border mb-4">
                <h3 className="font-weight-bold mb-3">예약정보</h3>
            </div>
            <div className="row r_mb_down p-0">
                    <div className="col-3 pl-0">
                        <span className="font-weight-bold d-block r_s_size">예약일</span>
                        <span className="d-none" id="s_tel"></span>
                    </div>
                    <div className="col-9">
                        <div id="si_date" className="text-right">{s_date}</div>
                    </div>
            </div>
            <div className="row mb-4 p-0">
                <h3 className="font-weight-bold mb-3">금액정보</h3>
            </div>
            <div className="row p-0">
                    <div className="col-4 pl-0">
                        <span className="font-weight-bold d-block r_s_size">서비스명</span>
                    </div>
                    <div className="col-8">
                        <div className="mb-3 text-right"><span className="font-weight-bold" id="service_price">{s_cate}</span></div>
                    </div>
            </div>
            <hr className="r_mg_top_none"/>
            <div className="row r_mbdown p-0">
                    <div className="col-3 pl-0">
                        <span className="font-weight-bold d-block r_s_size r_nowrap">총 결제 금액</span>
                    </div>
                    <div className="col-9">
                        <div className="r_r_color font-weight-bold text-right r_s_size" id="totalPrice">{totalPrice(data2)}원</div>
                    </div>
                    
            </div>
        </>
    )
}

function ReservationInfo({ history, location, match }) {

    const session = JSON.parse(window.sessionStorage.result);
    const {u_type,u_id} = session;
    const query = queryString.parse(location.search);
    let s_date = query.date;
    let si_id = query.si_id;
    let checked = query.checked;
    console.log('checked : ', checked)

    const [data, setData] = useState([]);
    const [data2, setData2] = useState([]);


    const {si_name,si_address} = data;
    const {s_img,s_name,s_price,s_member_price,s_cate} = data2;

    const [r_obj, setObj] = useState({
        r_gubun:'',
        r_status:'예약완료',
        si_id:si_id,
        ag_id:u_id,
        s_id:'',
        r_reserve_date:s_date,
    })


    const goBack = () => {
        history.push('/');
    }
 
    const onClick = () => {
        history.push('/repReserve?si_id='+si_id);
    }
    

    const style ={
        color:'red'
    }

    console.log('data2 : ', data2);


  return (
    <>
    <Container className="mb-5">
        <div className="c_pad">
        <TopTitle title="신청내역 확인  " />
            <SigongId si_id={si_id} setData={setData} data={data}/>
            <ServiceId 
            u_id={u_id} 
            u_type={u_type} 
            s_date={s_date} 
            setData2={setData2} 
            data2={data2} 
            />
            <div className="row mb-2 p-0">
                <div className="col-12 text-center pl-0 pr-0">
                    <span className="btn btn-primary r_btnsize" onClick={()=> history.push('/myReserve')}>나의 신청내역</span>
                    
                </div>
            </div>
            <div className="row mb-2 p-0">
                {
                    checked == 1 &&
                    <>
                    <div className="col-12 text-center pl-0 pr-0 mb-2">
                        <span className="btn btn-primary r_btnsize">지금 결제하기</span>
                    </div>
                    <div className="col-12 text-center pl-0 pr-0">
                        <span className="btn btn-outline-secondary r_btnsize"  onClick={onClick}>현장 결제</span>
                    </div>
                    </>
                }
                 
            </div>
            <div className="row mb-2 p-0">
                <span className="col-12 btn btn-primary r_btnsize" onClick={goBack}>뒤로가기</span>
            </div>
        </div>
        
    </Container>
   
    </>
    
  );
}

export default ReservationInfo;
